import React from 'react';
import Modal from "react-modal";
import "./DownloadModal.css";
import Error from "../../../assets/lottie/Error.json";
import Lottie from "lottie-react";

const DownloadModal = (props) => {
    const { openFailModal, setOpenFailModal, failMessage, recallFunctionOnOk, recallFunctiononClose } = props;

    const closeModal = () => {
        setOpenFailModal(false);
        recallFunctiononClose();
    };

    const handleOkButtonClick = () => {
        recallFunctionOnOk();
        closeModal();
    };

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    const style = {
        width: "24%",
        height: "109px",
        margin: "0 auto",
        display: "flex",
        justifycontent: "center",
        alignItems: "center"
    };

    return (
        <div>
            <Modal
                isOpen={openFailModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="inner-fail-modal">
                    <div className="close-btn" onClick={closeModal}><span>X</span></div>
                    <div className="fail-image">
                        <Lottie animationData={Error} style={style} />
                    </div>
                    <div className="modal-message">
                        {failMessage}
                    </div>
                    <div className="ok-btn">
                        <button onClick={handleOkButtonClick}>Yes</button>
                        <button style={{ marginLeft: "75px" }} onClick={closeModal}>No</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default DownloadModal;
